import tw, { styled } from 'twin.macro';

export const ModalBackdrop = styled.div`
  ${tw`
    fixed
    inset-0
    z-50
    flex
    items-center
    justify-center
  `}
  background-color: rgba(0, 0, 0, 0.85);
`;

export const ModalContent = styled.div`
  ${tw`
    relative
    w-full
    h-full
    p-6
  `}
  background: #0b0b0b;

  @media (max-width: 900px) {
    width: 100vw;
    height: 100vh;
    padding: 1rem;
    border-radius: 0;
  }
`;

export const ModalHeader = styled.div`
  ${tw`
    flex
    items-center
    justify-between
    gap-4
  `}
`;

export const ModalHeaderControls = styled.div`
  ${tw`
    flex
    items-center
    gap-3
  `}
`;

export const ModalTitle = styled.h3`
  ${tw`
    text-2xl
    font-bold
    mt-4
  `}

  @media (max-width: 900px) {
    font-size: 1.25rem;
  }
`;

export const ModalDescription = styled.p`
  ${tw`
    text-sm
    text-gray-300
    mb-4
  `}
`;

export const ModalClose = styled.button`
  ${tw`
    text-white
    text-xl
    font-bold
  `}
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const ModalNavButton = styled.button`
  ${tw`
    text-white
    text-xl
    font-bold
    px-2
  `}
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const ModalToggleButton = styled.button`
  ${tw`
    text-xs
    font-semibold
    px-3
    py-1
    rounded-full
  `}
  background: ${(props) => (props.$active ? '#e50914' : 'rgba(255,255,255,0.15)')};
  color: ${(props) => (props.$active ? '#fff' : '#d1d5db')};
  border: 1px solid rgba(255, 255, 255, 0.25);
  cursor: pointer;
`;

export const ModalBody = styled.div`
  ${tw`
    relative
    w-full
    h-[70vh]
    mt-4
    flex
    items-center
    justify-center
  `}

  @media (max-width: 900px) {
    height: calc(100vh - 12rem);
  }

  @media (max-width: 600px) {
    height: calc(100vh - 13.5rem);
  }
`;

export const ModalVideo = styled.video`
  ${tw`
    w-full
    h-full
  `}
  background: #000;
  object-fit: contain;
`;

export const ModalPlayButton = styled.button`
  ${tw`
    absolute
    text-2xl
    font-bold
    w-16
    h-16
    rounded-full
    flex
    items-center
    justify-center
  `}
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.6);
  color: white;
  cursor: pointer;
`;

export const ModalProgress = styled.div`
  ${tw`
    mt-3
  `}
`;

export const ModalProgressBar = styled.div`
  ${tw`
    h-1
    rounded-full
  `}
  background: rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    transform: scaleX(${(props) => props.$progress});
    transform-origin: left;
    background: #e50914;
  }
`;

export const ModalProgressLabel = styled.div`
  ${tw`
    text-xs
    text-gray-400
    mt-2
  `}
`;
